import Button from "@app/sharedComponents/Button/Button"
import PageHeaders from "@app/sharedComponents/CommonHeader/CommonHeader"
import { themeColorSet, ThemedPressable, ThemedText, ThemedView } from "@app/theme"
import { ScrollView,Image, Platform } from "react-native"
import {RadioButton,Circle, WarningCircle} from '@app/sharedComponents/Icons/Icons';
import Svg, { Line } from "react-native-svg";
import { useEffect, useState } from "react";
import { endpoints } from "@app/api/apis";
import axios from "axios";
import { useAppSelector } from "@app/store/hooks";
import { LENDER_ID } from "@app/constants/platformPartners";
import { formatIndianCurrency } from "@app/utils/utility";
import BajajPaymentBreakup from "./components/BajajPaymentBreakup";
import DSPPaymentBreakup from "./components/DSPPaymentBreakup";
import TATAPaymentBreakup  from "./components/TATAPaymentBreakup";
import BankTransferDetails from "./components/BankTransferDetails";
import ROUTE from "@app/navigationApp/routes";
import { NativeStackScreenProps } from "@react-navigation/native-stack";
import { PrivateStackParamList } from "@app/navigationApp/types";
import ForeClosureData from "./components/ForeClosureData";
import BottomSheetContainer from "@app/sharedComponents/Bottomsheet/Bottomsheet";
import InterestStatus from "./components/InterestStatus";
import {  checkColor, isFromTDLPlatform, REPAYMENT_COLLECTION_TYPE, trackEvent } from "@app/utils";
import DashedLine from "@app/sharedComponents/DashedLine/DashedLine";
import useDSPPayment from "@app/hooks/useDSPPayment";
import useTataPayment from "@app/hooks/useTataPayment";
import useBajajPayment from "@app/hooks/useBajajPayment";


type ScreenProps = NativeStackScreenProps<PrivateStackParamList, 'CONFIRM_PAYMENT_DETAILS'>

interface RouteParams {
    selectedAmount: number;
    paymentType: string;
    isFromForeclosure?: boolean;
    isFromClearDues?: boolean;
}
export enum PaymentStatuses  {
    COLLECTION_COMPLETE = 'COLLECTION_COMPLETE',

    SETTLED = 'SETTLED',
    SUCCESS_WITH_LENDER_RECON_FAILED = 'SUCCESS_WITH_LENDER_RECON_FAILED',
    FAILED = 'FAILED',

    PENDING_SETTLEMENT = 'PENDING_SETTLEMENT',
    CANCELLED = 'CANCELLED'
}
const routesMap = {
    FLEXI_PAY:"principal",
    INTEREST_PAYMENT:"interest",
    SHORTFALL_REPAY:"shortfall",
}

const ConfirmPay =({navigation,route} : ScreenProps)=>{
    const params = route?.params ?? {} as RouteParams;
    const selectedAmount = params.selectedAmount ?? 0;
    const paymentType = params.paymentType ?? '';
    const isFromForeclosure = params?.isFromForeclosure ?? false;
    const isFromClearDues = params?.isFromClearDues ?? false;
    const firebaseParams = useAppSelector((state) => state.firebaseParams);
    const creditInfo = useAppSelector((state) => state.auth.creditDetails);
    const interestDetails = useAppSelector((state) => state.auth.interestDetails);
    const userDetails = useAppSelector((state) => state.auth.userDetails);
    const shortFallDetails = useAppSelector((state) => state.auth.shortFallDetails);
    const foreClosureData = useAppSelector((state) => state.auth.foreclosureDetails);
    const {lendingPartnerId,chargesDue,creditId} = userDetails?.linkedCredits[0];
    const [selectedPaymentMethod,setSelectedPaymentMethod] = useState('');
    const [bankTransferDetails,setBankTransferDetails] = useState({});
    const userProfile = useAppSelector((state) => state.auth.userProfile);
    const isDecreaseForeclosureFlow = paymentType === REPAYMENT_COLLECTION_TYPE.FORECLOSURE;
    const [openInprogressModal,setOpenInProgressModal] = useState(false);
    const {startDSPPayment,loading:isDspPaymentLoading}= useDSPPayment();
    const { startTataPayment,loading:isTataPaymentLoading } = useTataPayment();
    const {isfromTDL} = useAppSelector((state) => state.platformParams);
    const { startBajajPayment,loading:isBajajaymentLoading } = useBajajPayment();
    const isLoading = isDspPaymentLoading || isTataPaymentLoading || isBajajaymentLoading;
    const PrincipalAmount = creditInfo?.principalOutStandingAmount || 0;
    const isForeclosureWithNegativeAmount = paymentType === REPAYMENT_COLLECTION_TYPE.FORECLOSURE && selectedAmount < 0
    const fetchBankTransferDetails = ()=>{
        const url = endpoints.bankTransferDetails + userDetails?.linkedCredits[0]?.creditId
        axios.get(url).then((res)=>{
            if(paymentType===REPAYMENT_COLLECTION_TYPE.IN_APP_INTEREST_COLLECTION){
              setBankTransferDetails(res?.data?.interestRepaymentBankAccountDetails??res?.data?.principleRepaymentBankAccountDetails)
            } else{
              setBankTransferDetails(res?.data?.principleRepaymentBankAccountDetails)
            }
        })
        .catch((err)=>{
            console.log('bankTransferDetails',err)
        })
    }

    useEffect(()=>{
        fetchBankTransferDetails();
    },[]);

    const startPayment = async () => {
        if(selectedAmount <= 0){
            navigation.navigate(ROUTE.CONFIRM_LOAN_DETAILS)
        }
        else if (lendingPartnerId?.toLowerCase() === LENDER_ID.BAJAJ) {
            await startBajajPayment({
                selectedAmount,
                creditId,
                paymentType,
                isDecreaseForeclosureFlow,
                navigation,
                setOpenInProgressModal,
            });
        }
        else if (lendingPartnerId?.toLowerCase() === LENDER_ID.DSP) {
            await startDSPPayment(
                selectedAmount,
                creditId,
                paymentType,
                isDecreaseForeclosureFlow,
                navigation,
                userDetails,
            );
        }
        else if (lendingPartnerId?.toLowerCase() === LENDER_ID.TATA) {
            await startTataPayment({
                selectedAmount,
                creditId,
                paymentType,
                isDecreaseForeclosureFlow,
                navigation,
                setOpenInProgressModal,
            });
        }
    }

    const closeBottomSheet = () => {
        setOpenInProgressModal(false);
    };

    const paymentModeSelected = (mode: string) => {
        setSelectedPaymentMethod(mode);
        trackEvent("PAYMENT_MODE_SELECTED",{mode:mode.toLowerCase()})
    }
    return(
    <>
        <PageHeaders pageName="ConfirmPay" label="Confirm & pay" navigation={navigation} />
        <ScrollView style={{flex:1,backgroundColor:isfromTDL?'#fff':themeColorSet["bg-surface-page"], paddingBottom:16}}>
        {isFromForeclosure === true && 
            <ForeClosureData
                foreClosureData={foreClosureData}
                lenderId={lendingPartnerId}
                paymentType={paymentType}
                selectedAmount={selectedAmount}
                isFromForeclosure={isFromForeclosure}
                isFromClearDues={isFromClearDues}
            />
        }
        {isFromForeclosure === false && 
        <ThemedView m="lg" borderWidth={1} borderColor="border-primary" borderRadius="sm">   
               <ThemedView px='md' backgroundColor="milk" borderTopLeftRadius="sm" 
                borderTopRightRadius="sm"  >
                <ThemedView  py='lg'
                    flexDirection="row" 
                    justifyContent="space-between" 
                    >
                    <ThemedText variant="b2s" color="text-primary">
                    Selected amount 
                    </ThemedText>
                    <ThemedView flexDirection="row" alignItems="center">
                        <ThemedText variant="l2" color="text-primary">
                        {selectedAmount<0 && '-'}₹
                        </ThemedText>

                        <ThemedText variant="h2s" color="text-primary">
                            {formatIndianCurrency(selectedAmount)}
                        </ThemedText>
                    </ThemedView>

                </ThemedView>
             <DashedLine/>
            </ThemedView>
                {lendingPartnerId?.toLowerCase() === LENDER_ID.BAJAJ && 
                    <BajajPaymentBreakup 
                        paymentType={paymentType}
                        selectedAmount={selectedAmount}
                        interestDetails={interestDetails}
                        shortFallDetails={shortFallDetails}
                        principalOutStandingAmount={PrincipalAmount}
                    />
                }
                {lendingPartnerId?.toLowerCase() === LENDER_ID.DSP && 
                    <DSPPaymentBreakup  
                        paymentType={paymentType}
                        selectedAmount={selectedAmount}
                        interestDetails={interestDetails}
                        shortFallDetails={shortFallDetails}
                        chargesDue={chargesDue}
                        principalOutStandingAmount={PrincipalAmount}
                    />
                }
                {lendingPartnerId?.toLowerCase() === LENDER_ID.TATA && 
                    <TATAPaymentBreakup  
                        interestDetails={interestDetails}
                        shortFallDetails={shortFallDetails}
                        selectedAmount={selectedAmount}
                        chargesDue={chargesDue}
                        principalOutStandingAmount={PrincipalAmount}
                    />  
                }
        </ThemedView>
        }
        <InterestStatus
            firebaseParams={firebaseParams}
            interestDetails={interestDetails}
            bankDetails={userProfile?.bankDetails}
            selectedAmount={selectedAmount}
        />
       {selectedAmount > 0  && 
            <ThemedView p='md' mx='lg' borderWidth={1} borderColor="border-primary" borderRadius="sm"  backgroundColor="bg-surface-primary">
                <ThemedText variant="h6s" color="text-primary">
                    Choose payment method
                </ThemedText>
                <ThemedView mt='md' pt='md' borderTopColor="border-primary" borderTopWidth={1}>
                    <ThemedPressable mb='lg'  flexDirection="row" alignItems="center" justifyContent="space-between" onPress={()=>paymentModeSelected('ONLINE')}>
                        <ThemedView flexDirection="row" alignItems="center" > 
                        <Image 
                        source={{
                            uri:`https://volt-images-alpha.s3.ap-south-1.amazonaws.com/Online_pay.png`}} 
                            style={{width:46,height:46}}
                        />
                        <ThemedView ml="sm">
                            <ThemedText variant="h6s" color="text-primary"  mb='xs' >
                            Online payment
                            </ThemedText>
                            <ThemedText variant="b4r" color="text-secondary">
                            Using UPI, cards, or net banking
                            </ThemedText>
                        </ThemedView>
                        </ThemedView>
                        {
                        selectedPaymentMethod === 'ONLINE' ?
                        <RadioButton size={24} weight="fill" color={checkColor("#1434CB")}/> :
                        <Circle size={24}  color="#C0D1E7"/>
                    }
                    </ThemedPressable>
                    <DashedLine/>
                    <ThemedPressable my="lg"  flexDirection="row" alignItems="center" justifyContent="space-between" onPress={()=>paymentModeSelected('BANK_TRANSFER')}>
                        <ThemedView flexDirection="row" alignItems="center"> 
                        <Image 
                        source={{
                            uri:`https://volt-images-alpha.s3.ap-south-1.amazonaws.com/Bank+Transfer.png`}} 
                            style={{width:46,height:46}}
                        />
                        <ThemedView ml="sm">
                            <ThemedText variant="h6s" color="text-primary" mb='xs'>
                            Bank transfer
                            </ThemedText>
                            <ThemedText variant="b4r" color="text-secondary">
                            Via NEFT, RTGS, IMPS
                            </ThemedText>
                        </ThemedView>
                        </ThemedView>
                        {
                        selectedPaymentMethod === 'BANK_TRANSFER' ?
                        <RadioButton size={24} weight="fill" color={checkColor("#1434CB")}/> :
                        <Circle size={24}  color="#C0D1E7"/>
                    }
                    </ThemedPressable>
                {
                    selectedPaymentMethod === 'BANK_TRANSFER' &&
                    <BankTransferDetails bankTransferDetails={bankTransferDetails} userName={userProfile?.name}/>
                }
                </ThemedView>
            </ThemedView>
        }
        </ScrollView>
        {(selectedPaymentMethod === 'ONLINE' || isForeclosureWithNegativeAmount)&&
        <>
            <ThemedView p='lg' bg='bg-surface-primary' borderTopWidth={1} borderTopColor='border-primary'>
                <Button size="MD" type='SOLID' label={isForeclosureWithNegativeAmount ? 'Get refund & foreclose':'Pay now'} handlePress={startPayment} buttonLoader={isLoading}/>
            </ThemedView>
        </>}
        {(selectedAmount <= 0 && isFromClearDues) &&
        <ThemedView p='lg' bg='bg-surface-primary' borderTopWidth={1} borderTopColor='border-primary'>
            <Button size="MD" type='SOLID' label='Go to home' handlePress={()=>navigation.navigate(ROUTE.HOME)} buttonLoader={isLoading}/>
        </ThemedView>
        }
        <BottomSheetContainer
                isVisible={openInprogressModal}
                close={closeBottomSheet}
                closeOnBackdropPress={true}
                borderTopRightRadius={10}
                borderTopLeftRadius={10}
                onClose={undefined} 
                dragComponent={undefined} 
                containerStyle={undefined}>
            <ThemedView p='lg' mt='2xl' style={{}}>
                <ThemedText>Waiting for response</ThemedText>
                <ThemedView  mt='xl'>
                    <ThemedText>Please wait while we process your request</ThemedText>
                </ThemedView>
            </ThemedView>
        </BottomSheetContainer>
    </>
    )
}

export default ConfirmPay